import React from 'react';
import * as styles from './PageContent.module.scss';

interface PageContentProps {
  children: React.ReactNode;
}

const PageContent = ({ children }: PageContentProps) => {
  return <div className={styles.pageContent}>{children}</div>;
};

export default PageContent;
